import { walletDefinitions } from '@blockcatio/tabby-library/lib/utilities/walletTypes';

export const isInteractive = (state) => {
  const {
    account: { walletType },
  } = state;
  if (!walletType) {
    return null;
  }
  const walletDefinition = walletDefinitions.find(def => def.type === walletType);
  const { isInteractive: result } = walletDefinition;
  return result;
};

export const isLoading = (state) => {
  const automatic = isInteractive(state);
  const {
    account: {
      walletType, network, validContract, web3Provided, address, balance, catBalance,
    },
    app: { latestBlockNumber },
  } = state;

  // prompt user for wallet
  if (!walletType) {
    return false;
  }

  if (!network) {
    return true;
  }

  if (validContract === false) {
    return false;
  }

  if (automatic) {
    if (web3Provided === null) {
      return true;
    }
    if (web3Provided === false) {
      return false;
    }
  }

  if (address) {
    if (!balance) {
      return true;
    }
    if (!catBalance) {
      return true;
    }
  }

  if (latestBlockNumber === 0) {
    return true;
  }

  return false;
};

export const isNotProvided = state => isInteractive(state) && state.account.web3Provided === false;

export const isLocked = state =>
  isInteractive(state) && state.account.web3Provided && !state.account.address;

export const isMissingWeb3 = state =>
  state.account.walletType === 'browser' && state.account.web3Provided === false;

export const walletCanSend = ({ account: { walletType } }) => {
  const walletDefinition = walletDefinitions.find(def => def.type === walletType);
  return walletDefinition ? walletDefinition.isInteractive : false;
};

export const getAddress = ({ account: { address } }) => address;



// WEBPACK FOOTER //
// ./src/selectors/account.js